<template>
  <div class="Recommend">
    <p class="othersCx">
      为你推荐：
      <a href="javascript:;" v-for="(word,index) in recommendWords" :key="index" @click="forSearch(word);countAd(4518)">{{word}}</a>
    </p>
  </div>
</template>

<script>
export default {
  props: {
      recommendWords: {
          type:Array,
          default: () => []
      }
  },
  methods: {
      forSearch(word) {
          this.$global.q = word
          this.$EventBus.$emit('searchFromRecommend',word)
      }
  },
  name: "Recommend",
};
</script>

<style lang="scss" scoped>
.Recommend {
	color: #333333;
    font-size: 14px;
    border-bottom: 1px solid #eeeeee;
    padding-bottom: 10px;
    margin-bottom: 10px;
	.othersCx {
		a {
			color: #225599;
			font-weight: bold;
			margin-right: 15px;	
			text-decoration: underline;		
		}
	}
}
</style>
